export class tcAuthorizationAccess {
    Id: Number
    ProjectId: Number
    ConfigurationId: Number
    Assemblies: Assembly[]
    UserId: Number
    IsReadAccess : boolean
    IsReadOrWriteAccess : boolean
    CreatedBy:Number
    BusinessAreaId:Number
    BusinessLineId:Number
}

export class Assembly {
    AssemblyName: string
    
   // Product:Number[]
}